import ContentFeedService from "./contentFeed.service";
import { DataWrapper } from "../interfaces/DataWrapper";
import { HttpMethods } from "../enums/HttpMethods";
import { Author } from "../interfaces/Author";
import qs from "qs";

class AuthorsService {
  public static getAll(): Promise<Author[]> {
    return ContentFeedService.sendRequest<DataWrapper<Author[]>>(
      HttpMethods.GET,
      "authors"
    )
      .then((wrappedAuthors: DataWrapper<Author[]>) => wrappedAuthors.data)
      .catch((error: Error) => {
        throw error;
      });
  }

  public static getByName(name: string, type: string): Promise<Author[]> {
    const query = qs.stringify(
      {
        filters: {
          $and: [
            { name: { $containsi: name } },
          ],
        },
      }
    );

    return ContentFeedService.sendRequest<void>(HttpMethods.GET, `authors?${query}`)
      .then((wrappedAuthors: DataWrapper<Author[]>) => wrappedAuthors.data)
      .catch((error: Error) => {
        throw error;
      })
  }
}

export default AuthorsService;
